import { connect } from 'react-refetch';

export default connect;
